export { default } from './Legal';